/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Footer from "./Footer/Footer";
import HeaderOptimized from "./Header/HeaderOptimized";
import { useDispatch, useSelector } from "react-redux";
import {
  ClientInfo,
  getConfigValue,
  normalizeJourneyType,
  REWARD_JOURNEY_TYPE,
  trackEvent,
} from "../Components/Utility/Utility";
import NonLoginModal from "../Components/NonLoginModal/NonLoginModal";
import { fetchHomepageLayout } from "../Store/Slices/homepageLayoutSlice";
import { onGetCardMasterData } from "../Store/Slices/cardMasterSlice";
// import { onGetMail } from "../Store/Slices/sendMailSlice";
// import { onSaveCredsGet } from "../Store/Slices/cardDataSlice";



const Layout = (props) => {
  const { Component } = props;
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const clientinfo = ClientInfo();
  const configClient = clientinfo?.title?.trim().toLowerCase();
  const homepageLayout = useSelector(
    (state) => state.homepageLayoutReducer?.layout
  );
  const homepageLayoutStatus = useSelector(
    (state) => state.homepageLayoutReducer?.status
  );
  const promotionalItem = Array.isArray(homepageLayout)
    ? homepageLayout.find(
      (entry) => entry?.component === "PromotionalStrip" || entry?.id === "promotionalStrip"
    )
    : null;
  const showPromotionalStrip = homepageLayoutStatus === "succeeded"
    ? Boolean(promotionalItem) && promotionalItem.enabled !== false
    : true;
  const promotionalStripPlacement = promotionalItem?.placement === "belowHeader"
    ? "belowHeader"
    : "aboveHeader";
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isLoginDisable = getConfigValue(clientConfigurations, "isLogin");

    const handleConfirm = () => {
    const redirectUrl = isLoginDisable?.url;
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  useEffect(() => {
    // dispatch(onGetMail())
    // dispatch(onSaveCredsGet("V3IntegrationFront"));
    sessionStorage.removeItem("apiCalled");
    const isLogin = sessionStorage.getItem("login");
    if (isLoginDisable?.isLoginDisabled === 1 && !isLogin && !sessionStorage.getItem("blockDirectUrl")) {
      setModalOpen(true);
    }
  }, []);

  useEffect(() => {
    if (configClient) dispatch(fetchHomepageLayout(configClient));
  }, [configClient, dispatch]);

  useEffect(() => {
    if (
      clientinfo?.clientData?.id &&
      normalizeJourneyType(clientinfo?.clientData?.journeyType) ===
        REWARD_JOURNEY_TYPE.CARD
    ) {
      dispatch(onGetCardMasterData());
    }
  }, [clientinfo?.clientData?.id, clientinfo?.clientData?.journeyType, dispatch]);

  return (
    <>
      <HeaderOptimized
        setModalOpen={setModalOpen}
        modalOpen={modalOpen}
        showPromotionalStrip={showPromotionalStrip}
        promotionalStripPlacement={promotionalStripPlacement}
      />
      <Component />
      <NonLoginModal show={modalOpen} onConfirm={handleConfirm} />
      <Footer />
    </>
  );
};

export default Layout;
